import React, { useState, useEffect } from "react";
import { Col, Row, Button, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useParams } from "react-router";
import { SOMETHING_ERR } from "../../../helper/Constant";
import BTNLoader from "../../../components/BTNLoader";
import AlertDismissible from "../../../components/AlertDismissible";
import AuthPermissionMsg from "../../../components/AuthPermissionMsg";
import { useChangeProfilePasswordMutation } from "../../../features/common/CommonAPI";
import { Grid, TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const ChangePassword = () => {
    const { id } = useParams();
    const [showPassword, setShowPassword] = useState({
        old: false,
        new: false,
        confirm: false,
    });

    const toggleVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: "",
        oldPassword: ""
    });

    const [errors, setErrors] = useState({});
    const [changeProfilePassword, { isLoading, isSuccess, error, data }] = useChangeProfilePasswordMutation();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };


    const validateForm = () => {
        const newErrors = {};
        if (!formData.oldPassword) newErrors.oldPassword = "Old Password is required.";
        if (!formData.newPassword) newErrors.newPassword = "New Password is required.";
        if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm Password is required.";
        if (formData.newPassword !== formData.confirmPassword)  newErrors.confirmPassword = "Passwords do not match.";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            await changeProfilePassword({ id, ...formData }).unwrap();
            setFormData({ newPassword: "", confirmPassword: "", oldPassword: "" });

        } catch (err) {
            console.error("Error submitting password change:", err);
        }
    };


    return (
        <>
            <div className="d-md-flex" style={{ justifyContent: "space-between", padding: "10px 0" }}>
                <h1 className="title-admins-table">{id ? "Update" : "Change"} Password</h1>
            </div>

            {isSuccess && <AlertDismissible is={true} msg={data?.message} />}
            {error && <AlertDismissible is={false} msg={error?.data?.message || SOMETHING_ERR} />}
            <div className="mb-3"><AuthPermissionMsg /></div>

            <Row>
                <Col md={12}>
                    <Card>
                        <Card.Body>
                            <div className="user_details cutoms-login-artist mt-2">
                                <Grid container spacing={2}>
                                    {/* Old Password */}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            label="Old Password"
                                            name="oldPassword"
                                            type={showPassword.old ? 'text' : 'password'}
                                            value={formData.oldPassword}
                                            onChange={handleInputChange}
                                            fullWidth
                                            error={!!errors.oldPassword}
                                            helperText={errors.oldPassword}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => toggleVisibility('old')}>
                                                            {showPassword.old ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    {/* New Password */}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            label="New Password"
                                            name="newPassword"
                                            type={showPassword.new ? 'text' : 'password'}
                                            value={formData.newPassword}
                                            onChange={handleInputChange}
                                            fullWidth
                                            error={!!errors.newPassword}
                                            helperText={errors.newPassword}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => toggleVisibility('new')}>
                                                            {showPassword.new ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    {/* Confirm Password */}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            type={showPassword.confirm ? 'text' : 'password'}
                                            value={formData.confirmPassword}
                                            onChange={handleInputChange}
                                            fullWidth
                                            error={!!errors.confirmPassword}
                                            helperText={errors.confirmPassword}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => toggleVisibility('confirm')}>
                                                            {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid  item md={12} xs={12} className="text-end">
                                        {isLoading ? (
                                            <updateUserProfile className={"btn btn-primary"} />
                                        ) : (
                                            <button className="btn btn-primary" type="button" onClick={handleSubmit}>
                                                {id ? "Update" : "Change Password"}
                                            </button>
                                        )}
                                    </Grid>
                                </Grid>

                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ChangePassword;
